var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    _c("article", { staticClass: "news news--single" }, [
      _c("div", { staticClass: "container-fluid pb-3 pt-3" }, [
        _c("header", { staticClass: "news__header" }, [
          _c("h1", { staticClass: "news__title" }, [
            _vm._v(_vm._s(_vm.page.title)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "news__content",
          domProps: { innerHTML: _vm._s(_vm.page.content) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }